import { render, staticRenderFns } from "./rule-form-tab2.vue?vue&type=template&id=07b66111&"
import script from "./rule-form-tab2.vue?vue&type=script&lang=ts&"
export * from "./rule-form-tab2.vue?vue&type=script&lang=ts&"
import style0 from "./rule-form-tab2.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports